module.exports = __webpack_public_path__ + "img/help.bf0920b7.svg";